export default {
  title: 'Invoices',
  // MON-4 decision D: invoice-specific badge copy, not the generic
  // status.pending/unpaid strings shared with parcels in the common
  // namespace. See liff/src/lib/invoiceStatus.ts.
  status: {
    paid: 'Paid',
    pending_payment: 'Awaiting payment',
    overdue: 'Overdue',
    partially_paid: 'Partially paid',
  },
  test_mode_amount: 'TEST MODE: ฿{{amount}}',
  amount_via_promptpay: '฿{{amount}} via PromptPay',
  invoice_number: 'Invoice #{{number}}',
  billed_at: 'Billed',
  due_at: 'Due',
  total: 'Total',
  amount_paid: 'Paid',
  remaining: 'Remaining',
  items: 'Items',
  payments: 'Payment History',
  no_invoices: 'No invoices found',
  no_payment_methods: 'No online payment methods configured. Please contact your property manager.',
  pay_button: 'Pay ฿{{amount}}',
  payment_method: 'Payment Method',
  promptpay: 'PromptPay (QR)',
  credit_card: 'Credit Card',
  bank_transfer: 'Bank Transfer',
  bank_transfer_details: 'Transfer to the following account',
  bank_name: 'Bank',
  account_name: 'Account Name',
  account_number: 'Account Number',
  transfer_amount: 'Amount to transfer',
  upload_slip: 'Upload transfer slip',
  tap_to_upload: 'Tap to select slip image',
  submit_slip: 'Submit Slip',
  slip_submitted: 'Slip Submitted',
  pending_verification: 'Waiting for admin to verify your payment.',
  scan_qr: 'Scan QR Code to Pay',
  generating_qr: 'Generating QR Code...',
  waiting_confirmation: 'Waiting for payment confirmation...',
  payment_success: 'Payment Successful!',
  payment_failed: 'Payment Failed',
  card_details: 'Card Details',
  confirm_payment: 'Confirm Payment',
  polling_message: 'Checking payment status...',
  download_pdf: 'Download Invoice PDF',
  errors: {
    stripe_not_configured: 'Online payment is not available. Please contact your property manager.',
  },
}
